@if (show()) {<button class="edit-btn" (click)="click()">{{translationsService.translate('WebGalis_Edit')}}</button>}